<template>
  <header class="grid-container grid-x align-justify align-middle padding-bottom-xs padding-top-xs">
    <a
      class="brand-logo"
      href="/"
      :aria-label="brandAriaPrefix+' home'"
    />

    <button
      v-if="cxoUseButtonForBagLink"
      aria-label="Shopping Bag"
      @click="goToBag"
    >
      <span class="bag-icon-button" />
    </button>
    <a
      v-else
      class="bag-icon"
      href="/my/bag"
      aria-label="Shopping Bag"
    />
  </header>
</template>
<script setup>
import { useStore } from 'vuex';

const brandAriaPrefix = (process.env.ENTRY_POINT === 'mcom') ? 'Macy\'s' : 'Bloomingdales\'s';

const store = useStore();
const { cxoUseButtonForBagLink } = store.state?.envProps || {};

function goToBag() {
  window.location.assign('/my/bag');
}

</script>
<style src="appSCSS" lang='scss'></style>
<style src="./css/mcom.scss" brand="mcom" lang="scss" scoped/>
<style src="./css/bcom.scss" brand="bcom" lang="scss" scoped/>
